import React, { useEffect, useCallback, useMemo, useState } from "react";

import { useAuth0V2 } from "@stadium/services/auth0";
import { useMutation } from "@stadium/services/apollo-client";
import { logoutRef } from "@stadium/services/auth/client";

import { getPubNubServiceInstance } from "@services/pubnub";
import { createSession } from "@graphql/mutations/session/create-session";

import { useCurrentUserContext } from "@stadium/hooks/lib/use-current-user";
import { SloContext } from "@stadium/hooks/lib/use-slo";

export { SloContext };

const emptyObj = {};

const SloWrapper = ({ children }) => {
  const { isAuthenticated, logout } = useAuth0V2();
  const [createSessionRequest] = useMutation(createSession);

  const { currentUserData } = useCurrentUserContext();
  const { spreeId: userId } = currentUserData;

  const [uid, setUid] = useState();
  const [sloChannel, setSloChannel] = useState();

  const createSessionHandler = useCallback(
    (userAgent) => {
      return createSessionRequest({ variables: { input: { userAgent } } });
    },
    [createSessionRequest],
  );

  const pbListener = useMemo(
    () => ({
      message: (messageEvent) => {
        if (logoutRef?.current) return;
        if (messageEvent.message?.slo === true) {
          logout({ client_id: null, returnTo: window.location.origin });
        }
      },
    }),
    [logout],
  );

  useEffect(() => {
    let pubnub = null;

    if (isAuthenticated && userId) {
      createSessionHandler(window.navigator.userAgent)
        .then(({ data }) => {
          const { uid, channel } = data?.createSession || emptyObj;
          setUid(uid);
          setSloChannel(channel);

          getPubNubServiceInstance(uid).then((pubnubService) => {
            pubnub = pubnubService;
            pubnub.addListener(pbListener);
            pubnub.subscribe({ channels: [channel] });
          });
        })
        .catch((error) => {
          throw error;
        });
      return () => {
        if (pubnub) {
          pubnub.removeListener(pbListener);
          pubnub.unsubscribeAll();
        }
      };
    }
  }, [isAuthenticated, userId, pbListener, createSessionHandler]);

  const value = useMemo(() => {
    return { sloChannel, uid };
  }, [sloChannel, uid]);

  return <SloContext.Provider value={value}>{children}</SloContext.Provider>;
};

export default SloWrapper;
